'use strict';

class StepMenuController {
    constructor() {
        this.availableStepListMenuController = null;
        this.availableStepList = [];
    }

    getTimelineListData() {
        const training = TrainingTreeController._trainingFeature.getTrainingData();
        const folderMap = new Map();
        const rootFolders = [];

        training.directories.forEach(directory => {
            if (directory.type === 'TimelineFolder') {
                directory.isFolder = true;
                directory.children = [];
                folderMap.set(directory.id, directory);
            }
        });

        folderMap.forEach(folder => {
            if (folder.parent) {
                const parentFolder = folderMap.get(folder.parent);
                if (parentFolder) {
                    parentFolder.children.push(folder);
                } else {
                    rootFolders.push(folder);
                }
            } else {
                rootFolders.push(folder);
            }
        });

        training.timelines.forEach(timeline => {
            timeline.isFolder = false;
            const parentFolder = folderMap.get(timeline.parent);
            if (parentFolder) {
                parentFolder.children.push(timeline);
            } else {
                rootFolders.push(timeline);
            }
        });

        const sortedRootFolders = rootFolders.filter(f => f.isFolder);
        const rootFiles = rootFolders.filter(f => !f.isFolder);
        return [...sortedRootFolders, ...rootFiles];
    }

    createNewTrainingStep() {
        const training = TrainingTreeController._trainingFeature.getTrainingData();
        const timeStamp = getTimeStamp();
        const keyboardCallbacks = {};

        keyboardCallbacks.enterCallback = function (stepName) {
            mController.loadAndResetSavedMenuState();
            if (!stepName.trim().length) {
                const vrText = "Step name can not be empty";
                VRMessageController.addMessage({text: vrText, priority: VrMessagePriorityEnum.LOWPRIORITYINFO});
                return;
            }

            if (training.timelines.some(timeline => timeline.name.toLowerCase() === stepName.toLowerCase())) {
                alert("Name already exists. Please provide a new step name");
                return;
            }

            const sceneData = SceneStateController.saveState();
            wv.communicator.socket.communicateWithContainer({
                message: "createStepFromWorkspace",
                name: stepName,
                sceneData: sceneData
            });

            ARAuthoringController.restoreARAuthoringAfterStepCreation = true;
        };

        keyboardCallbacks.cancelCallback = function () {
            mController.loadAndResetSavedMenuState();
        };

        keyboardController.toggleState(keyboardController.getVRKeyboardParent(), keyboardCallbacks, "Step_" + timeStamp);
    }

    addCreateNewStepButton(parentMenuController, prop) {
        let self = this;
        let clickMenuItem = new ClickMenuItem(CreateNewStepButton.menuItemName, "Create Step", null, function () {
            self.createNewTrainingStep();
        });
        clickMenuItem.isVisible = prop.isVisible;
        clickMenuItem.isPresenter = prop.isPresenter;
        clickMenuItem.isViewer = prop.isViewer;
        parentMenuController.appendMenuItem(undefined, undefined, clickMenuItem);
    }

    insertStepFile(file) {
        const createNewFolderMenu = (item) => {
            item.resourceId = item.hasOwnProperty('resourceId') ? item.resourceId : item.id;
            item.id = generateUUID();
            let menuData = new ToggleTypeMenuData(item.id, 1, 10, undefined, updateParentUponSelection, {
                id: item.id,
                resourceId: item.resourceId
            });
            menuData.title = item.name;
            menuData.text = item.name;
            menuData.isListTypeMenu = true;
            let menuController = new MenuController(menuData);
            menuController.setMenuControlParameter(VR.scene, iq3Camera.camera, wv.selectionSphere);
            menuData.isFolder = true;

            menuController.setMenuItemWidth(0.23);
            menuController.setMenuItemHeight(0.02);
            menuController.setCloseButtonAppear(true);
            menuController.setBackAndCloseItemWidth(0.052);
            menuController.setTextAlignType(TextAlignTypeEnum.left);

            for (const child of item.children) {
                if (child.isFolder) {
                    const newFolderData = createNewFolderMenu(child);
                    menuData.addItem(newFolderData);
                } else {
                    child.resourceId = child.hasOwnProperty('resourceId') ? child.resourceId : child.id;
                    child.id = generateUUID();
                    const newItem = new ToggleCheckTypeMenuItem(child.id, child.name, false, updateParentUponSelection, {
                        id: child.id,
                        resourceId: child.resourceId
                    });
                    menuData.addItem(newItem);
                }
            }

            return menuData;
        };

        const updateParentUponSelection = (currentSelection, userData) => {
            const menuItem = this.availableStepListMenuController.menuData.getMenuItemByName(userData.id);
            if (menuItem.parent && menuItem.parent.menuData instanceof ToggleTypeMenuData) {
                let selectionData = true;
                menuItem.parent.menuData.items.forEach(child => {
                    if (child instanceof ToggleTypeMenuData || child instanceof ToggleCheckTypeMenuItem) {
                        selectionData = selectionData && child.currentSelection;
                    }
                })
                menuItem.parent.menuData.updateCheckbox(selectionData);
            }
        };

        let newItemData;

        if (file.isFolder) {
            newItemData = createNewFolderMenu(file);
        } else {
            file.resourceId = file.hasOwnProperty('resourceId') ? file.resourceId : file.id;
            file.id = generateUUID();
            newItemData = new ToggleCheckTypeMenuItem(file.id, file.name, false, updateParentUponSelection, {
                id: file.id,
                resourceId: file.resourceId
            });
        }

        let availableView = mController.menuDataView.getThisMenuView(LoadTrainingStepMenu.menuItemName);

        if (availableView && availableView.isMenuDrawn()) {
            mController.menuDataView.insertThisMenuItemToRunningMenuData(LoadTrainingStepMenu.menuItemName, newItemData);
            availableView.refresh();
        } else {
            let menuData = mController.menuData.getThisMenuData(LoadTrainingStepMenu.menuItemName);
            if (menuData) {
                menuData.addItem(newItemData);
            }
        }
    }

    setStepFileList(stepList) {
        let self = this;

        let availableView = mController.menuDataView.getThisMenuView(LoadTrainingStepMenu.menuItemName);
        completelyRemoveThisMenuView(mController, availableView, LoadTrainingStepMenu.menuItemName);

        this.availableStepList = [];

        stepList.forEach(file => {
            self.insertStepFile(file);
            this.availableStepList.push(file);
        });
    }

    getSelectedStepsFromMenuItems() {
        const stepMenuItemsArray = [];
        const ids = [];
        const names = [];
        getMenuItemsFromMultiPageList(this.availableStepListMenuController.menuData, stepMenuItemsArray);

        for (let i in stepMenuItemsArray) {
            const menuItem = stepMenuItemsArray[i];
            if (menuItem.currentSelection) {
                ids.push(menuItem.userData.resourceId);
                names.push(menuItem.text);
                menuItem.updateCheckbox(false);
            }
        }
        return { ids, names };
    }

    loadTrainingStepsFromXRMEnu() {
        wv.communicator.socket.communicateWithContainer({
            message: "getTrainingData"
        });

        const selected = this.getTrainingSteps();
        if (!selected) {
            return;
        }

        wv.communicator.socket.communicateWithContainer({
            message: "setActiveStep",
            stepId: selected.selectedStepIds[0]
        });
    }

    getTrainingSteps() {
        const { ids: selectedStepIds, names: selectedStepNames } = this.getSelectedStepsFromMenuItems();

        if (!selectedStepIds || selectedStepIds.length === 0) {
            return null;
        }

        if (selectedStepIds.length > 1) {
            VRMessageController.addMessage({
                text: "Please select only one step",
                priority: VrMessagePriorityEnum.HIGHPRIORITYINFO
            });
            return null;
        }

        return { selectedStepIds, selectedStepNames };
    }

    async overwriteTrainingStepsFromXRMEnu() {
        const selected = this.getTrainingSteps();
        if (!selected) {
            return;
        }

        const { selectedStepIds, selectedStepNames } = selected;
        const stepName = selectedStepNames[0];
        saveCurrentMenuItemState();
        wv.promptWindow3dObject.changeText("This will overwrite the Step: " + stepName + ".\nDo you want to proceed?");
        wv.promptWindow3dObject.askNow(function (value) {
            if (value) {
                wv.communicator.socket.communicateWithContainer({
                    message: "overwriteScenesFromWorkspace",
                    stateId: selectedStepIds[0]
                });
            }
            mController.loadAndResetSavedMenuState();
        });
    }

    updateAvailableListSelection(value) {
        let menuView = getCurrentActiveMenuView(mController);
        let stepNameArray = [], folderArray = [];

        getMenuItemsFromMultiPageList(menuView.menuData, stepNameArray, folderArray);

        for (let i in stepNameArray) {
            stepNameArray[i].updateCheckbox(value);
        }

        for (let i in folderArray) {
            folderArray[i].updateCheckbox(value);
        }

        if (menuView.menuData.hasOwnProperty('updateCheckbox')) {
            menuView.menuData.updateCheckbox(value);
        }
    }

    initAvailableStepListMenu() {
        const onRefreshButtonClicked = () => {
            wv.communicator.socket.communicateWithContainer({
                message: "getTrainingData"
            });
        };

        const addCommandMenuButtonsForAvailableFiles = (menuController) => {
            let menuItem = new ClickMenuItem("selectAllButton_step", "Select All", true, this.updateAvailableListSelection.bind(this));
            menuController.addCommandMenuItem(menuItem);
            menuItem = new ClickMenuItem("loadButton_step", "Load", undefined, this.loadTrainingStepsFromXRMEnu.bind(this));
            menuController.addCommandMenuItem(menuItem);
            menuItem = new ClickMenuItem("overwriteButton_step", "Overwrite", undefined, this.overwriteTrainingStepsFromXRMEnu.bind(this));
            menuController.addCommandMenuItem(menuItem);
            menuItem = new ClickMenuItem("deselectAllButton_step", "Deselect All", false, this.updateAvailableListSelection.bind(this));
            menuController.addCommandMenuItem(menuItem);
            menuItem = new ClickMenuItem("refreshStepFiles", "Refresh\nStep Files", false, onRefreshButtonClicked);
            menuController.addCommandMenuItem(menuItem);
        };

        this.availableStepList = new MenuData('Available Steps', 1, 10);
        this.availableStepList.isListTypeMenu = true;

        this.availableStepListMenuController = new MenuController(this.availableStepList);

        this.availableStepListMenuController.setMenuItemWidth(0.23);
        this.availableStepListMenuController.setMenuItemHeight(0.02);
        this.availableStepListMenuController.setCloseButtonAppear(true);
        this.availableStepListMenuController.setBackAndCloseItemWidth(0.052);
        this.availableStepListMenuController.setTextAlignType(TextAlignTypeEnum.left);

        addCommandMenuButtonsForAvailableFiles(this.availableStepListMenuController);

        this.availableStepListMenuController.setMenuControlParameter(VR.scene, iq3Camera.camera, wv.selectionSphere);
    }

    addLoadTrainingStepMenu(parentMenuController, prop) {
        try {
            this.initAvailableStepListMenu();
            this.availableStepList.isVisible = prop.isVisible;
            this.availableStepList.isPresenter = prop.isPresenter;
            this.availableStepList.isViewer = prop.isViewer;
            let menuText = prop.text || LoadTrainingStepMenu.text;
            parentMenuController.appendMenuItem(LoadTrainingStepMenu.menuItemName, menuText, this.availableStepList);
        } catch (error) {
            console.error('Training Editor Error in Load Step list menu. Error: ' + error);
        }
    }

    updateLoadTrainingStepMenu() {
        const stepList = this.getTimelineListData();
        this.setStepFileList(stepList);
    }

    addStepMenuFrameAlertText(parentMenuController, prop) {
        let clickMenuItem = new ClickMenuItem(StepMenuFrameButton.menuItemName, "Add Step\nMenu Frame", null, async function () {

            if (StepInstructionScreenManager.focusCameraOnStepInstructionScreen()) {
                return;
            }

            const parentForMode = VR.scene;

            const {worldPosition, worldQuaternion} = computePoseInFrontOfCamera(2.0);
            let {position, quaternion} = toLocalPose(worldPosition, worldQuaternion, parentForMode);
            await mController.menuDataView.closeMenu();

            const newScreen = await StepInstructionScreenManager.create({
                modelId: EMPTY_PARAMETER,
                width: StepMenu.width,
                height: StepMenu.width * .75,
                title: "Default title",
                additionalText: "Default Additional Text",
                fontSize: 0.045,
                buttons: [],
                screenID: generateUUID(),
                parentInVr: VR.scene,
                position,
                quaternion
            });
        });
        clickMenuItem.isVisible = prop.isVisible;
        clickMenuItem.isPresenter = prop.isPresenter;
        clickMenuItem.isViewer = prop.isViewer;
        parentMenuController.appendMenuItem(undefined, undefined, clickMenuItem);
    }
}

export default new StepMenuController();
